// @flow

import React from "react";
import type {Product} from "../../models/Product";
import {currencyConverter} from "../../helper/currency";
import "./GridPrice.scss";
import PickupLocationContainer from "../../container/pickupLocation/PickupLocationContainer";
import {determineDistributionChannelForPriceDisplay, isDiscounted, isOnSale} from "../../models/Product";

export type GridPriceProps = {
    t: any,
    product: Product,
    showPrice: boolean,
    needsPickupLocation: boolean,
    showMSRP: boolean,
}


const GridPrice = (props: GridPriceProps) => {
    const {product, showPrice, needsPickupLocation, showMSRP} = props;
    const {distributionChannels, unitPrice} = product;

    const isMountingOnly = distributionChannels.mounting && !distributionChannels.shipping && !distributionChannels.pickup;
    const showDiscountRate = isDiscounted(product);

    // if product is on sale, we need to determine from which distributionChannel to take the historic price info
    // and all other prices from the same distributionChannel
    const isSale = isOnSale(product);
    const distChannel = determineDistributionChannelForPriceDisplay(product);
	const historicMinimalPrice = isSale ? distChannel?.historicMinimalPrice : undefined;
    const price = isSale ? distChannel?.price : product.price;
    const recommendedRetailPrice = isSale ? distChannel?.recommendedRetailPrice : product.recommendedRetailPrice;
    const discountRate = showDiscountRate ? distChannel?.discountRate : 0;

	return (
		<div className="hpm-gridPriceBox">
			{(showPrice && needsPickupLocation && isMountingOnly)
				? (<div className="hpm-price">
						<PickupLocationContainer linkLabel={props.t("location.headline")}
												 classNames={"gridLocationSelect"}
												 linkStyle={{
													 display: "flex",
													 width: "100%",
													 justifyContent: "flex-end",
													 fontSize: "0.85rem",
													 whiteSpace: "nowrap"
												 }}
												 redirectToOverview={true}
						/>
					</div>
				)
				: (showPrice && (
					<div className={showDiscountRate ? "hpm-sale-price" : "hpm-price"}>
						{price ? currencyConverter(price) : props.t("productDetail.priceOnRequest")}
					</div>
				)
			)}
			{price && unitPrice && (
				<div className="unit-price">
					<small>
						({currencyConverter(unitPrice.pricePerUnit)} / {unitPrice.measuringUnit === "sqm" ? "m²" : unitPrice.measuringUnit === "cbm" ? "m³" : unitPrice.measuringUnit})
					</small>
				</div>
			)}
			{historicMinimalPrice && (
				<div className={"historic-price"}>
					<span className={"historic-label"}>{props.t("productDetail.historicMinimalPurchasePrice")}</span>
					<div className="historic-values-wrapper">
						{showDiscountRate && <span className={"discount-rate"}>-{discountRate}%</span>}
						<span className={showDiscountRate ? "historic-value" : ""}>{currencyConverter(historicMinimalPrice)}</span>
					</div>
				</div>
			)}
			{showMSRP && recommendedRetailPrice && (
				<div className="hpm-retailPrice">
					<span className="retail-label">{props.t("productDetail.recommendedRetailPrice")}</span>
					<span className="retail-value">{recommendedRetailPrice && currencyConverter(recommendedRetailPrice)}</span>
				</div>
			)}
        </div>
    );
}

export default GridPrice;
